import { render, staticRenderFns } from "./chapters.index.vue?vue&type=template&id=62d56eb1&scoped=true&"
import script from "./chapters.index.vue?vue&type=script&lang=ts&"
export * from "./chapters.index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d56eb1",
  null
  
)

export default component.exports